export { N20MainMenu } from './components/N20MainMenu';
